export const CityMunicipalityList = [
    { province: "Abra", 
        cityList: [
            "Bangued",
            "Boliney",
            "Bucay",
            "Bucloc",
            "Daguioman",
            "Danglas",
            "Dolores",
            "La Paz",
            "Lacub",
            "Lagangilang",
            "Lagayan",
            "Langiden",
            "Licuan-Baay (Licuan)",
            "Luba",
            "Malibcong",
            "Manabo",
            "Peñarrubia",
            "Pidigan",
            "Pilar",
            "Sallapadan",
            "San Isidro",
            "San Juan",
            "San Quintin",
            "Tayum",
            "Tineg",
            "Tubo",
            "Villaviciosa",
        ] 
    },
    { province: "Agusan del Norte", 
        cityList: [
            "Buenavista",
            "Butuan",
            "Cabadbaran",
            "Carmen",
            "Jabonga",
            "Kitcharao",
            "Las Nieves",
            "Magallanes",
            "Nasipit",
            "Remedios T. Romualdez",
            "Santiago",
            "Tubay",
        ] 
    },
    { province: "Agusan del Sur", 
        cityList: [
            "Bayugan",
            "Bunawan",
            "Esperanza",
            "La Paz",
            "Loreto",
            "Prosperidad",
            "Rosario",
            "San Francisco",
            "San Luis",
            "Santa Josefa",
            "Sibagat",
            "Talacogon",
            "Trento",
            "Veruela",
        ] 
    },
    { province: "Aklan",
        cityList: [
            "Altavas",
            "Balete",
            "Banga",
            "Batan",
            "Buruanga",
            "Ibajay",
            "Kalibo",
            "Lezo",
            "Libacao",
            "Madalag",
            "Makato",
            "Malay",
            "Malinao",
            "Nabas",
            "New Washington",
            "Numancia",
            "Tangalan",
        ] 
    },
    { province: "Albay",
        cityList: [
            "Bacacay",
            "Camalig",
            "Daraga",
            "Guinobatan",
            "Jovellar",
            "Legazpi City",
            "Libon",
            "Ligao",
            "Malilipot",
            "Malinao",
            "Manito",
            "Oas",
            "Pio Duran",
            "Polangui",
            "Rapu-Rapu",
            "Santo Domingo",
            "Tabaco",
            "Tiwi",
        ] 
    },
    { province: "Antique",
        cityList: [
            "Anini-y",
            "Barbaza",
            "Belison",
            "Bugasong",
            "Caluya",
            "Culasi",
            "Hamtic",
            "Laua-an",
            "Libertad",
            "Pandan",
            "Patnongon",
            "San Jose de Buenavista",
            "San Remigio",
            "Sebaste",
            "Sibalom",
            "Tibiao",
            "Tobias Fornier",
            "Valderrama",
        ] 
    },
    { province: "Apayao",
        cityList: [
            "Calanasan",
            "Conner",
            "Flora",
            "Kabugao",
            "Luna",
            "Pudtol",
            "Santa Marcela",
        ] 
    },
    { province: "Aurora",
        cityList: [
            "Baler",
            "Casiguran",
            "Dilasag",
            "Dinalungan",
            "Dingalan",
            "Dipaculao",
            "Maria Aurora",
            "San Luis",
        ] 
    },
    { province: "Basilan", 
        cityList: [] 
    },
    { province: "Bataan",
        cityList: [
            "Abucay",
            "Bagac",
            "Balanga",
            "Dinalupihan",
            "Hermosa",
            "Limay",
            "Mariveles",
            "Morong",
            "Orani",
            "Orion",
            "Pilar",
            "Samal",
        ] 
    },
    { province: "Batanes", 
        cityList: [] 
    },
    { province: "Batangas",
        cityList: [
            "Agoncillo",
            "Alitagtag",
            "Balayan",
            "Balete",
            "Batangas City",
            "Bauan",
            "Calaca",
            "Calatagan",
            "Cuenca",
            "Ibaan",
            "Laurel",
            "Lemery",
            "Lian",
            "Lipa",
            "Lobo",
            "Mabini",
            "Malvar",
            "Mataasnakahoy",
            "Nasugbu",
            "Padre Garcia",
            "Rosario",
            "San Jose",
            "San Juan",
            "San Luis",
            "San Nicolas",
            "San Pascual",
            "Santa Teresita",
            "Santo Tomas",
            "Taal",
            "Talisay",
            "Tanauan",
            "Taysan",
            "Tingloy",
            "Tuy",
        ] 
    },
    { province: "Benguet", 
        cityList: [] 
    },
    { province: "Biliran", 
        cityList: [] 
    },
    { province: "Bohol", 
        cityList: [] 
    },
    { province: "Bukidnon", 
        cityList: [] 
    },
    { province: "Bulacan",
        cityList: [
            "Angat",
            "Balagtas",
            "Baliuag",
            "Bocaue",
            "Bulacan",
            "Bustos",
            "Calumpit",
            "Doña Remedios Trinidad",
            "Guiguinto",
            "Hagonoy",
            "Malolos",
            "Marilao",
            "Meycauayan",
            "Norzagaray",
            "Obando",
            "Pandi",
            "Paombong",
            "Plaridel",
            "Pulilan",
            "San Ildefonso",
            "San Jose del Monte",
            "San Miguel",
            "San Rafael",
            "Santa Maria",
        ] 
    },
    { province: "Cagayan", 
        cityList: [] 
    },
    { province: "Camarines Norte", 
        cityList: [] 
    },
    { province: "Camarines Sur",
        cityList: [
            "Baao",
            "Balatan",
            "Bato",
            "Bombon",
            "Buhi",
            "Bula",
            "Cabusao",
            "Calabanga",
            "Camaligan",
            "Canaman",
            "Caramoan",
            "Del Gallego",
            "Gainza",
            "Garchitorena",
            "Goa",
            "Iriga",
            "Lagonoy",
            "Libmanan",
            "Lupi",
            "Magarao",
            "Milaor",
            "Minalabac",
            "Nabua",
            "Naga",
            "Ocampo",
            "Pamplona",
            "Pasacao",
            "Pili",
            "Presentacion",
            "Ragay",
            "Sagñay",
            "San Fernando",
            "San Jose",
            "Sipocot",
            "Siruma",
            "Tigaon",
            "Tinambac",
        ] 
    },
    { province: "Camiguin", 
        cityList: [] 
    },
    { province: "Capiz", 
        cityList: [] 
    },
    { province: "Catanduanes", 
        cityList: [] 
    },
    { province: "Cavite",
        cityList: [
            "Alfonso",
            "Amadeo",
            "Bacoor",
            "Carmona",
            "Cavite City",
            "Dasmariñas",
            "General Emilio Aguinaldo",
            "General Mariano Alvarez",
            "General Trias",
            "Imus",
            "Indang",
            "Kawit",
            "Magallanes",
            "Maragondon",
            "Mendez",
            "Naic",
            "Noveleta",
            "Rosario",
            "Silang",
            "Tagaytay",
            "Tanza",
            "Ternate",
            "Trece Martires",
        ] 
    },
    { province: "Cebu",

        cityList: [
            "Alcantara",
            "Alcoy",
            "Alegria",
            "Aloguinsan",
            "Argao",
            "Asturias",
            "Badian",
            "Balamban",
            "Bantayan",
            "Barili",
            "Bogo",
            "Boljoon",
            "Borbon",
            "Carcar",
            "Carmen",
            "Catmon",
            "Cebu City",
            "Compostela",
            "Consolacion",
            "Cordova",
            "Daanbantayan",
            "Dalaguete",
            "Danao",
            "Dumanjug",
            "Ginatilan",
            "Lapu-Lapu City",
            "Liloan",
            "Madridejos",
            "Malabuyoc",
            "Mandaue",
            "Medellin",
            "Minglanilla",
            "Moalboal",
            "Naga",
            "Oslob",
            "Pilar",
            "Pinamungajan",
            "Poro",
            "Ronda",
            "Samboan",
            "San Fernando",
            "San Francisco",
            "San Remigio",
            "Santa Fe",
            "Santander",
            "Sibonga",
            "Sogod",
            "Tabogon",
            "Tabuelan",
            "Talisay",
            "Toledo",
            "Tuburan",
            "Tudela",
        ] 
    },
    { province: "Cotabato", 
        cityList: [] 
    },
    { province: "Davao de Oro", 
        cityList: [] 
    },
    { province: "Davao del Norte", 
        cityList: [] 
    },
    { province: "Davao del Sur", 
        cityList: [] 
    },
    { province: "Davao Occidental", 
        cityList: [] 
    },
    { province: "Davao Oriental", 
        cityList: [] 
    },
    { province: "Dinagat Islands", 
        cityList: [] 
    },
    { province: "Eastern Samar", 
        cityList: [] 
    },
    { province: "Guimaras", 
        cityList: [] 
    },
    { province: "Ifugao", 
        cityList: [] 
    },
    { province: "Ilocos Norte", 
        cityList: [] 
    },
    { province: "Ilocos Sur", 
        cityList: [] 
    },
    { province: "Iloilo",
        cityList: [
            "Ajuy",
            "Alimodian",
            "Anilao",
            "Badiangan",
            "Balasan",
            "Banate",
            "Barotac Nuevo",
            "Barotac Viejo",
            "Batad",
            "Bingawan",
            "Cabatuan",
            "Calinog",
            "Carles",
            "Concepcion",
            "Dingle",
            "Dueñas",
            "Dumangas",
            "Estancia",
            "Guimbal",
            "Igbaras",
            "Iloilo City",
            "Janiuay",
            "Lambunao",
            "Leganes",
            "Lemery",
            "Leon",
            "Maasin",
            "Miagao",
            "Mina",
            "New Lucena",
            "Oton",
            "Passi",
            "Pavia",
            "Pototan",
            "San Dionisio",
            "San Enrique",
            "San Joaquin",
            "San Miguel",
            "San Rafael",
            "Santa Barbara",
            "Sara",
            "Tigbauan",
            "Tubungan",
            "Zarraga",
        ] 
    },
    { province: "Isabela", 
        cityList: [] 
    },
    { province: "Kalinga", 
        cityList: [] 
    },
    { province: "La Union", 
        cityList: [] 
    },
    { province: "Laguna",
        cityList: [
            "Alaminos",
            "Bay",
            "Biñan",
            "Cabuyao",
            "Calamba",
            "Calauan",
            "Cavinti",
            "Famy",
            "Kalayaan",
            "Liliw",
            "Los Baños",
            "Luisiana",
            "Lumban",
            "Mabitac",
            "Magdalena",
            "Majayjay",
            "Nagcarlan",
            "Paete",
            "Pagsanjan",
            "Pakil",
            "Pangil",
            "Pila",
            "Rizal",
            "San Pablo",
            "San Pedro",
            "Santa Cruz",
            "Santa Maria",
            "Santa Rosa",
            "Siniloan",
            "Victoria",
        ] 
    },
    { province: "Lanao del Norte", 
        cityList: [] 
    },
    { province: "Lanao del Sur", 
        cityList: [] 
    },
    { province: "Leyte",
        cityList: [
            "Abuyog",
            "Alangalang",
            "Albuera",
            "Babatngon",
            "Barugo",
            "Bato",
            "Baybay",
            "Burauen",
            "Calubian",
            "Capoocan",
            "Carigara",
            "Dagami",
            "Dulag",
            "Hilongos",
            "Hindang",
            "Inopacan",
            "Isabel",
            "Jaro",
            "Javier (Bugho)",
            "Julita",
            "Kananga",
            "La Paz",
            "Leyte",
            "MacArthur",
            "Mahaplag",
            "Matag-ob",
            "Matalom",
            "Mayorga",
            "Merida",
            "Ormoc",
            "Palo",
            "Palompon",
            "Pastrana",
            "San Isidro",
            "San Miguel",
            "Santa Fe",
            "Tabango",
            "Tabontabon",
            "Tacloban",
            "Tanauan",
            "Tolosa",
            "Tunga",
            "Villaba",
        ] 
    },
    { province: "Maguindanao", 
        cityList: [] 
    },
    { province: "Marinduque", 
        cityList: [] 
    },
    { province: "Masbate", 
        cityList: [] 
    },
    { province: "Misamis Occidental",
        cityList: [
            "Aloran",
            "Baliangao",
            "Bonifacio",
            "Calamba",
            "Clarin",
            "Concepcion",
            "Don Victoriano Chiongbian",
            "Jimenez",
            "Lopez Jaena",
            "Oroquieta",
            "Ozamiz",
            "Panaon",
            "Plaridel",
            "Sapang Dalaga",
            "Sinacaban",
            "Tangub",
            "Tudela",
        ] 
    },
    { province: "Misamis Oriental",
        cityList: [
            "Alubijid",
            "Balingasag",
            "Balingoan",
            "Binuangan",
            "Cagayan de Oro",
            "Claveria",
            "El Salvador",
            "Gingoog",
            "Gitagum",
            "Initao",
            "Jasaan",
            "Kinoguitan",
            "Lagonglong",
            "Laguindingan",
            "Libertad",
            "Lugait",
            "Magsaysay",
            "Manticao",
            "Medina",
            "Naawan",
            "Opol",
            "Salay",
            "Sugbongcogon",
            "Tagoloan",
            "Talisayan",
            "Villanueva",
        ] 
    },
    { province: "Mountain Province", 
        cityList: [] 
    },
    { province: "Negros Occidental",
        cityList: [
            "Bacolod",
            "Bago",
            "Binalbagan",
            "Cadiz",
            "Calatrava",
            "Candoni",
            "Cauayan",
            "Enrique B. Magalona",
            "Escalante",
            "Himamaylan",
            "Hinigaran",
            "Hinoba-an",
            "Ilog",
            "Isabela",
            "Kabankalan",
            "La Carlota",
            "La Castellana",
            "Manapla",
            "Moises Padilla",
            "Murcia",
            "Pontevedra",
            "Pulupandan",
            "Sagay",
            "Salvador Benedicto",
            "San Carlos",
            "San Enrique",
            "Silay",
            "Sipalay",
            "Talisay",
            "Toboso",
            "Valladolid",
            "Victorias",
        ] 
    },
    { province: "Negros Oriental",
        cityList: [
            "Amlan (Ayuquitan)",
            "Ayungon",
            "Bacong",
            "Bais",
            "Basay",
            "Bayawan (Tulong)",
            "Bindoy (Payabon)",
            "Canlaon",
            "Dauin",
            "Dumaguete",
            "Guihulngan",
            "Jimalalud",
            "La Libertad",
            "Mabinay",
            "Manjuyod",
            "Pamplona",
            "San Jose",
            "Santa Catalina",
            "Siaton",
            "Sibulan",
            "Tanjay",
            "Tayasan",
            "Valencia (Luzurriaga)",
            "Vallehermoso",
            "Zamboanguita",
        ] 
    },
    { province: "Northern Samar", 
        cityList: [] 
    },
    { province: "Nueva Ecija", 
        cityList: [] 
    },
    { province: "Nueva Vizcaya", 
        cityList: [] 
    },
    { province: "Occidental Mindoro", 
        cityList: [] 
    },
    { province: "Oriental Mindoro", 
        cityList: [] 
    },
    { province: "Palawan", 
        cityList: [] 
    },
    { province: "Pampanga", 
        cityList: [] 
    },
    { province: "Pangasinan", 
        cityList: [] 
    },
    { province: "Quezon",
        cityList: [
            "Jomalig",
            "Patnanungan",
            "Burdeos",
            "Polillo",
            "Panukulan",
            "General Nakar",
            "Infanta",
            "Real",
            "Mauban",
            "Sampaloc",
            "Lucban",
            "Tayabas",
            "Pagbilao",
            "Lucena",
            "Sariaya",
            "Candelaria",
            "Dolores",
            "Tiaong",
            "San Antonio",
            "Padre Burgos",
            "Agdangan",
            "Unisan",
            "Pitogo",
            "Macalelon",
            "General Luna",
            "Catanauan",
            "Buenavista",
            "San Narciso",
            "Mulanay",
            "San Francisco",
            "San Andres",
            "Perez",
            "Alabat",
            "Quezon",
            "Atimonan",
            "Plaridel",
            "Gumaca",
            "Lopez",
            "Calauag",
            "Guinayangan",
            "Tagkawayan",
        ] 
    },
    { province: "Quirino",
        cityList: [
            "Aglipay",
            "Cabarroguis",
            "Diffun",
            "Maddela",
            "Nagtipunan",
            "Saguday",
        ] 
    },
    { province: "Rizal",
        cityList: [
            "Angono",
            "Antipolo",
            "Baras",
            "Binangonan",
            "Cainta",
            "Cardona",
            "Jalajala",
            "Morong",
            "Pililla",
            "Rodriguez",
            "San Mateo",
            "Tanay",
            "Taytay",
            "Teresa",
        ] 
    },
    { province: "Romblon", 
        cityList: [] 
    },
    { province: "Samar", 
        cityList: [] 
    },
    { province: "Sarangani", 
        cityList: [] 
    },
    { province: "Siquijor", 
        cityList: [] 
    },
    { province: "Sorsogon", 
        cityList: [] 
    },
    { province: "South Cotabato", 
        cityList: [] 
    },
    { province: "Southern Leyte",
        cityList: [
            "Anahawan",
            "Bontoc",
            "Hinunangan",
            "Hinundayan",
            "Libagon",
            "Liloan",
            "Limasawa",
            "Maasin",
            "Macrohon",
            "Malitbog",
            "Padre Burgos",
            "Pintuyan",
            "Saint Bernard",
            "San Francisco",
            "San Juan (Cabalian)",
            "San Ricardo",
            "Silago",
            "Sogod",
            "Tomas Oppus",
        ] 
    },
    { province: "Sultan Kudarat", 
        cityList: [] 
    },
    { province: "Sulu", 
        cityList: [] 
    },
    { province: "Surigao del Norte", 
        cityList: [] 
    },
    { province: "Surigao del Sur", 
        cityList: [] 
    },
    { province: "Tarlac", 
        cityList: [] 
    },
    { province: "Tawi-Tawi", 
        cityList: [] 
    },
    { province: "Zambales",
        cityList: [
            "Botolan",
            "Cabangan",
            "Candelaria",
            "Castillejos",
            "Iba",
            "Masinloc",
            "Olongapo",
            "Palauig",
            "San Antonio",
            "San Felipe",
            "San Marcelino",
            "San Narciso",
            "Santa Cruz",
            "Subic",
        ]
    },
    { province: "Zamboanga del Norte", 
        cityList: [] 
    },
    { province: "Zamboanga del Sur", 
        cityList: [] 
    },
    { province: "Zamboanga Sibugay", 
        cityList: [] 
    },
    { province: "Metro Manila",
        cityList: [
            "Caloocan",
            "Las Piñas",
            "Makati",
            "Malabon",
            "Mandaluyong",
            "Manila City",
            "Marikina",
            "Muntinlupa",
            "Navotas",
            "Parañaque",
            "Pasay",
            "Pasig",
            "Pateros",
            "Quezon City",
            "San Juan",
            "Taguig",
            "Valenzuela",
        ] 
    },
];